<template>
    <v-app>
        <employee-advance-settlement :dialog="dialog" :data="data" @update:dialog="dialog = $event"/>

        <v-container fluid style="margin-top: -20px;">
            <v-row>
                <v-col cols="12">
                    <v-expansion-panels v-model="panel">
                        <v-expansion-panel>
                            <v-expansion-panel-title
                            color="blue-grey-lighten-4"
                            class="panel-header"
                            >
                                Employee Advance List
                            </v-expansion-panel-title>

                            <v-expansion-panel-text>
                                <v-row class="py-2">
                                    <v-col md="4" cols="12">
                                        <v-text-field
                                        v-model="search"
                                        append-inner-icon="mdi-magnify"
                                        label="Search"
                                        single-line
                                        hide-details
                                        density="compact"
                                        variant="outlined"
                                        bg-color="grey-lighten-4"
                                        class="pl-2"
                                        clearable
                                        ></v-text-field>
                                    </v-col>

                                    <v-col md="5" cols="12">
                                        <div class="d-flex align-center flex-column">
                                            <v-btn-group
                                            variant="outlined"
                                            density="compact"
                                            size="x-small"
                                            divided
                                            >
                                                <v-btn
                                                prepend-icon="mdi mdi-download"
                                                variant="flat"
                                                color="success"
                                                @click="exportToCSV"
                                                >CSV</v-btn>

                                                <v-btn
                                                prepend-icon="mdi mdi-download"
                                                variant="flat"
                                                color="primary"
                                                @click="exportToExcel"
                                                >EXCEL</v-btn>

                                                <v-btn
                                                prepend-icon="mdi mdi-download"
                                                variant="flat"
                                                color="red"
                                                @click="exportToPDF"
                                                >PDF</v-btn>
                                            </v-btn-group>
                                        </div>
                                    </v-col>

                                    <v-col md="3" cols="12">
                                        <!-- <div class="text-right pr-2">
                                            <v-btn
                                            v-if="$insertAccess($route.fullPath)"
                                            @click="goTo('/account/add-money-requisition')"
                                            color="primary"
                                            variant="tonal"
                                            prepend-icon="mdi mdi-plus"
                                            rounded="xl"
                                            >
                                                Create Requisition
                                            </v-btn>
                                        </div> -->
                                    </v-col>
                                </v-row>

                                <v-data-table
                                :headers="headers"
                                :items="getSchema"
                                :loading="loading"
                                v-model:items-per-page="itemsPerPage"
                                :search="search"
                                :hover="true"
                                density="compact"
                                >
                                    <template v-slot:item.index="{ index }">
                                        {{ ++index }}
                                    </template>

                                    <template v-slot:item.total_amount="{ item }">
                                        {{ formatCurrency(item.total_amount) }}
                                    </template>

                                    <template v-slot:item.status="{ item }">
                                        <v-chip
                                        :color="item.status == 1 ? 'success' : 'grey'"
                                        size="small"
                                        >
                                        {{ item.status == 1 ? "Active" : "Inactive" }}
                                        </v-chip>
                                    </template>

                                    <template v-slot:item.actions="{ item }">
                                        <v-tooltip text="Settle" location="top">
                                            <template v-slot:activator="{ props }">
                                                <v-btn
                                                v-bind="props"
                                                icon
                                                size="small"
                                                color="info"
                                                variant="text"
                                                @click="settleAdvance(item)"
                                                >
                                                    <v-icon>mdi-account-cash</v-icon>
                                                </v-btn>
                                            </template>
                                        </v-tooltip>
                                    </template>
                                </v-data-table>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref } from "vue";
import { toast } from "vue3-toastify";
import formattedDate from "@/plugins/dateFormatter";
import { useRouter } from "vue-router";
import statusMap from "@/utils/statusMap";
import employeeAdvanceSettlement from "@/components/module/accounts/employeeAdvance/employeeAdvanceSettlement.vue";

export default {
    components: {
        employeeAdvanceSettlement,
    },
    data: () => ({
        itemsPerPage: 10,
        panel: [0],
        loading: false,
        search: "",
        dialog: false,
        data: {},
        statusMap,
        headers: [
            { title: "#SL", align: "center", key: "index", width: "7%", sortable: false },
            { title: "Code", key: "code", align: "center", sortable: false },
            { title: "Employee", key: "employee.name", align: "left", sortable: false },
            { title: "Purpose", align: "left", key: "purpose", sortable: false },
            { title: "Disburse Amount", align: "end", key: "disburse_amount", sortable: true },
            { title: "Settle Amount", align: "end", key: "settle_amount", sortable: true },
            { title: "Status", align: "center", key: "status", sortable: true },
            { title: "Actions", align: "center", key: "actions", sortable: false },
        ],
    }),
    watch: {},
    created() {
        
        this.$store.dispatch("getMoneyRequisitionList", { advance_settle: 1});
        
    },
    computed: {
        getSchema() {
            return this.$store.getters.getMoneyRequisitionList;
        },
        getHrmEmployeeList() {
            return this.$store.getters.getHrmEmployeeList;
        },
    },
    setup() {},
    methods: {
        formattedDate,
        formatCurrency(value) {
            return new Intl.NumberFormat("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value || 0);
        },

        goTo(val) {
            this.$router.push({ path: val }).catch((err) => {});
        },
        openSettleAdvance() {
            this.data = {
                employee_id: null,
                money_requisition_master_id: null,
                settle_date: '',
                items: [],
                remarks: '',
                status: 1,
            };
            this.dialog = true;
        },

        settleAdvance(item) {
            this.data = { ...item };
            this.dialog = true;
        },

        prepareExportRows() {
            return this.getSchema.map((item, index) => ([
                index + 1,
                item.code,
                this.getEmployeeName(item.employee_id),
                item.purpose || "N/A",
                this.formatCurrency(item.disburse_amount),
                this.formatCurrency(item.settle_amount),
                this.formatCurrency(item.due_amount),
                this.formatCurrency(item.total_amount),
                item.status == 1 ? "Active" : "Inactive",
            ]));
        },

        exportToPDF() {
            const columns = [ "#SL", "Code", "Employee", "Purpose", "Disburse Amount", "Settle Amount", "Due Amount", "Total Amount", "Status", ];

            const rows = this.prepareExportRows();

            this.$exportTableToPDF(
                columns,
                rows,
                "Employee Advance List",
                "employee_advance_list_" + this.$fileDate(),
                "landscape"
            );
        },

        exportToExcel() {
            const data = [
                [ "#SL", "Code", "Employee", "Purpose", "Disburse Amount", "Settle Amount", "Due Amount", "Total Amount", "Status", ],
                ...this.prepareExportRows()
            ];

            this.$exportTableToExcel(
                data,
                "Employee Advance List",
                "employee_advance_list_" + this.$fileDate()
            );
        },

        exportToCSV() {
            const data = [
                [ "#SL", "Code", "Employee", "Purpose", "Disburse Amount", "Settle Amount", "Due Amount", "Total Amount", "Status", ],
                ...this.prepareExportRows()
            ];

            this.$exportTableToCSV(
                data,
                "employee_advance_list_" + this.$fileDate()
            );
        }

    },
    mounted() {
    },
    beforeUnmount() {
        this.$store.commit("UNSET_MONEY_REQUISITION_LIST");
    }
};
</script>

<style scoped>
.cursor-pointer {
    cursor: pointer;
}
</style>
